import parseDialogue from "../../util/parseDialogue";

export const DisarrayF8 = parseDialogue(`
disarray:f8:100-300

#100 Bravo, bravo. You have honestly surprised me. I never thought a newbie like you could get this far.
>200 You're next, Disarray.

#200 I'm afraid not. You see, you're too late. My grand finale is already at hand. Is everybody ready? I hope you're not afraid of the dark. Three, two, one, nightfall!
>300 No!
`);
